import type { ImageProps } from '2-core-elements/Image/Image';
import { resolveEventPagesToArticleCards, type EventPages } from './eventsCardResolver';

export type EventsCardProps = {
    img?: Pick<ImageProps, 'imgSrc' | 'imgAlt' | 'imgHeight' | 'imgWidth' | 'imgSrcSet'>;
    link?: { href: string; label?: string; target?: '_self' | '_blank' };
    title: string;
    startDate?: string;
    endDate?: string;
    time?: string;
    topic?: string[];
    category?: string[];
    summary?: React.ReactNode | string;
    children?: React.ReactNode | string;
};

interface EventsListingData {
    total: number;
    items: EventsCardProps[];
}

export const resolveEventsListing = (data: EventsListingData): EventsListingData | null => {
    const { items, total } = data;

    return {
        total: Number(total),
        items: resolveEventPagesToArticleCards(items as EventPages[]),
    };
};
